import PageTitle from '../components/PageTitle';
import Section from '../components/Section';

import Do_unto_others from '../assets/images/do_unto_others.svg';
import Connell_2010_An_Early_Spring from '../assets/images/content/Connell_2010_An_Early_Spring.jpg';

const FourCornerstones = () => {
	return (
		<>
			<PageTitle title="Four Cornerstones" />
			<div className="bg-[#F26721] text-white pt-12 md:py-24">
				<div className="container max-w-container-lg">
					<div className="grid md:grid-cols-[1fr_1fr] gap-6">
						<div className="col-start-2">
							<p className="font-late-serif text-[1.375rem] md:text-[1.65rem] leading-[1.6] mb-6">Our four cornerstones – who we are, why we are here, where we are headed, and how we will get there – are the construct Progressive uses to think about having a competitive advantage. These cornerstones permit all people associated with us to understand what we expect of ourselves and each other and how we conduct our business.</p>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div>
					<div className="grid md:grid-cols-[1fr_1fr] gap-6">
						<div className="grid bg-gradient-to-b from-[#F26721] from-50% to-white to-50% md:bg-none">
							<img className="max-w-[709px] w-full h-auto m-0 md:mt-[-265px] mx-auto px-4 sm:px-6" src={Connell_2010_An_Early_Spring} alt />
						</div>
						<div className="md:col-start-2 my-12 md:my-24 max-w-[550px] px-4 sm:px-6">
							<h2 className="heading-one text-[#4B7B9D] m-0">
								CORE VALUES &gt; <span className="font-light normal-case">Who We Are</span>
							</h2>
							<p>Progressive’s Core Values serve as the foundation for our culture. They represent our values, guide our decisions, and define how we conduct our business and interact with others. It’s essential that they’re understood and embraced by all Progressive people.</p>
							<p>
								<span className="text-[#F26721] heading-two">Integrity&nbsp;</span> We revere honesty and adhere to high ethical standards to gain the trust and confidence of our customers. We value transparency, encourage disclosing bad news, and welcome disagreement.
							</p>
							<p>
								<span className="text-[#F26721] heading-two">Golden Rule&nbsp;</span> We value and respect our differences, act with kindness and caring, and treat others as they want to be treated.
							</p>
							<p>
								<span className="text-[#F26721] heading-two">Objectives&nbsp;</span> We set ambitious goals and evaluate our performance by measuring what we achieve and how we achieve it. We’re committed to an inclusive and equitable workplace where rewards and promotion are based on results and ability.
							</p>
							<p>
								<span className="text-[#F26721] heading-two">Excellence&nbsp;</span> We strive to meet or exceed the expectations of our teammates, customers, partners, and investors by continuously improving and finding new ways to meet their needs.
							</p>
							<p>
								<span className="text-[#F26721] heading-two">Profit&nbsp;</span>
								We have a responsibility to ourselves, our customers, agents, and investors to be a profitable and enduring company by offering products and services consumers value.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div className="container max-w-[1485px]">
					<img src={Do_unto_others} className="w-full" alt="Do unto others" />
				</div>
			</div>
			<Section backgroundColor="#FEF0E9">
				<div className="container py-24 max-w-container-lg">
					<div className="grid md:grid-cols-[1fr_1fr] gap-6">
						<div>
							<h2 className="text-[#4B7B9D] font-trade-compressed m-0 tracking-widest leading-[1.2] text-[28px] md:text-[30px]">
								<span className="font-bold uppercase">Purpose</span> &gt; Why we’re here
							</h2>
							<p>Progressive exists to help people move forward and live fully.</p>
							<h2 className="text-[#4B7B9D] font-trade-compressed m-0 tracking-widest leading-[1.2] text-[28px] md:text-[30px]">
								<span className="font-bold uppercase">Vision</span> &gt; Where we’re headed
							</h2>
							<p>Become consumers’, agents’, and business owners’ #1 destination for insurance and other financial needs.</p>
							<h2 className="text-[#4B7B9D] font-trade-compressed m-0 tracking-widest leading-[1.2] text-[28px] md:text-[30px]">
								<span className="font-bold uppercase">Strategy</span> &gt; How we’ll get there
							</h2>
							<p>We will achieve our Vision through four Strategic Pillars:</p>
							<ol className="list-decimal">
								<li>Ensuring that our people and culture collectively remain our most powerful source of competitive advantage;</li>
								<li>Meeting the broader needs of our customers throughout their lifetimes;</li>
								<li>Maintaining a leading brand recognized for innovative offerings and supported by experiences that instill confidence; and</li>
								<li>Offering competitive prices driven by industry-leading segmentation, claims accuracy, and operational efficiency.</li>
							</ol>
						</div>
					</div>
				</div>
			</Section>
		</>
	);
};

export default FourCornerstones;
